import React from "react";

export default function H2withIcon(props) {
  return (
    <h1 className="font-medium lg:text-xl text-black flex items-center mb-4">
      {props.children}
    </h1>
  );
}
